module.exports = __webpack_public_path__ + "ef66b68b7629cda40ea6cf8d42959d5a.svg";